import React from 'react';

const LinkedinIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M20.447 20.452H17.2v-5.569c0-1.327-.025-3.037-1.85-3.037-1.853 0-2.137 1.445-2.137 2.94v5.666H9.065V9h3.123v1.561h.045c.435-.824 1.498-1.694 3.084-1.694 3.296 0 3.906 2.17 3.906 4.993v6.592zM5.337 7.433a1.812 1.812 0 1 1 0-3.624 1.812 1.812 0 0 1 0 3.624zm1.624 13.019H3.714V9h3.247v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.226.792 24 1.771 24h20.451C23.2 24 24 23.226 24 22.271V1.729C24 .774 23.2 0 22.225 0z" />
  </svg>
);

export default LinkedinIcon;
